import sheetSearchModal from "@/views/menu/sheet/operation/sheetSearchModal.vue";

export default {
    components: {
        sheetSearchModal
    },
    props: {},
    data () {
        return {
            // 高级筛选相关
            showSearchTpl: false,
            showSearchModal: false,
            searchParams: {},
            fulltextSearch: "",

            // 默认筛选相关
            showDefaultSearch: false,
            searchConditions: []
        };
    },
    computed: {
        curScreenSearchFormList () {
            // 过滤视图筛选的单选/多选选项
            let fieldsObj = this.curScreenAdvSearchConditions
                .filter(item => (item.fieldValue.length) && (item.fieldOperator === "eq") && ["select", "checkbox"].includes(item.fieldType))
                .reduce((obj, item) => ({ ...obj, [item.fieldKey]: item }), {});

            return this.$deepCopy(this.curScreenFormList).map(item => {
                if (fieldsObj[item._key]) {
                    item._data = item._data.filter(dataItem => fieldsObj[item._key].fieldValue.includes(dataItem._key));
                };

                return item;
            });
        }
    },
    methods: {
        /* ------ 高级筛选相关 --------- */
        // 点击高级筛选
        clickSearch () {
            this.showSearchTpl = true;
            this.openSearchModal();
        },
        // 打开高级筛选模态框
        openSearchModal () {
            this.showSearchModal = true;
        },
        // 关闭高级筛选模态框
        closeSearchModal () {
            this.showSearchModal = false;
        },
        // 切换高级筛选模态框
        toggleSearchModal (bool) {
            this.showSearchModal = bool;
        },
        // 高级筛选框渲染函数
        sheetSearchModalRender (h, params) {
            return this.showSearchTpl
                ? h("sheet-search-modal", {
                    props: {
                        value: this.showSearchModal,
                        formList: this.curScreenFormList,
                        initSearchFields: this.curScreenDefaultSearchFields
                    },
                    on: {
                        input: this.toggleSearchModal,
                        search: this.searchCb
                    }
                })
                : undefined;
        },
        // 高级筛选回调
        searchCb (searchParams) {
            this.searchParams = searchParams;
            this.search();
        },

        /* ------ 默认筛选相关 --------- */
        // 默认筛选渲染函数
        sheetDefaultSearchRender (h) {
            return this.curScreenDefaultSearchFields.length && this.displaySearch && this.showDefaultSearch
                ? h("dsh-default-search", {
                    style: {
                        background: "#fff",
                        padding: "10px",
                        borderRadius: "6px",
                        marginBottom: "10px"
                    },
                    props: {
                        initSearchFields: this.curScreenDefaultSearchFields.filter(fieldItem => fieldItem !== this.groupField),
                        formList: this.sourceType === "mod" ? this.curScreenSearchFormList : this.curScreenDbSearchFormList
                    },
                    on: {
                        change: this.defaultSearchCb
                    }
                })
                : undefined;
        },
        // 默认筛选回调
        defaultSearchCb (params) {
            this.searchConditions = params.conditions;
            this.search();
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/sheet/operation/searchBtnMixin.js